export const meta = {
  login: {
    title: 'ログイン',
    desc: 'マイナビRESIDENTのログイン画面です。',
    breadCrumb: [
      {
        label: 'ログイン'
      }
    ]
  },
  register: {
    title: '会員登録',
    desc: 'マイナビRESIDENTの会員登録画面です。'
  },
  registerConfirm: {
    title: '会員登録 確認',
    desc: ''
  },
  registerThanks: {
    title: '会員登録',
    desc: 'マイナビRESIDENTの会員登録画面です。',
    breadCrumb: [
      {
        label: '会員登録完了'
      }
    ]
  },
  hospitalsList: {
    title: '',
    desc: '',
    breadCrumb: [
      {
        label: '病院一覧'
      }
    ]
  },
  latterList: {
    title: '',
    desc: '',
    breadCrumb: [
      {
        label: '専門研修プログラム一覧'
      }
    ]
  },
  hospitalsDetail: {
    title: '',
    desc: '',
    breadCrumb: [
      {
        label: '病院一覧',
        link: '/search/hospital/list'
      }
    ],
    loader: true
  },
  visitApplicationInput: {
    title: '見学申し込み 入力',
    desc: '',
    breadCrumb: [
      {
        label: '見学申し込み 入力'
      }
    ],
    loader: true
  },
  visitApplicationConfirm: {
    title: '見学申し込み 確認',
    desc: '',
    breadCrumb: [
      {
        label: '見学申し込み 確認'
      }
    ]
  },
  visitApplicationThanks: {
    title: '見学申し込み 完了',
    desc: '',
    breadCrumb: [
      {
        label: '見学申し込み 完了'
      }
    ]
  },
  visitApplicationLatterInput: {
    title: '専門研修プログラム 見学申込み 入力',
    desc: '',
    breadCrumb: [
      {
        label: '専門研修プログラム 見学申し込み 入力'
      }
    ],
    loader: true
  },
  visitApplicationLatterConfirm: {
    title: '専門研修プログラム 見学申し込み 確認',
    desc: '',
    breadCrumb: [
      {
        label: '専門研修プログラム 見学申し込み 確認'
      }
    ]
  },
  visitApplicationLatterThanks: {
    title: '専門研修プログラム 見学申し込み 完了',
    desc: '',
    breadCrumb: [
      {
        label: '専門研修プログラム 見学申し込み 完了'
      }
    ]
  },
  documentRequestInput: {
    title: '資料請求 入力',
    desc: '',
    breadCrumb: [
      {
        label: '資料請求 入力'
      }
    ],
    loader: true
  },
  documentRequestConfirm: {
    title: '資料請求 確認',
    desc: '',
    breadCrumb: [
      {
        label: '資料請求 確認'
      }
    ]
  },
  documentRequestThanks: {
    title: '資料請求 完了',
    desc: '',
    breadCrumb: [
      {
        label: '資料請求 完了'
      }
    ]
  },
  documentRequestLatterInput: {
    title: '専門研修プログラム 資料請求 入力',
    desc: '',
    breadCrumb: [
      {
        label: '専門研修プログラム 資料請求 入力'
      }
    ],
    loader: true
  },
  documentRequestLatterConfirm: {
    title: '専門研修プログラム 資料請求 確認',
    desc: '',
    breadCrumb: [
      {
        label: '専門研修プログラム 資料請求 確認'
      }
    ]
  },
  documentRequestLatterThanks: {
    title: '専門研修プログラム 資料請求 完了',
    desc: '',
    breadCrumb: [
      {
        label: '専門研修プログラム 資料請求 完了'
      }
    ]
  },
  mypage: {
    title: 'マイページTOP',
    desc: '',
    breadCrumb: [
      {
        label: 'マイページTOP'
      }
    ],
    requireLogin: true
  },
  mypageBookmark: {
    title: '病院ブックマーク一覧',
    desc: '',
    breadCrumb: [
      {
        label: 'マイページTOP',
        link: '/mypage'
      },
      {
        label: '病院ブックマーク一覧'
      }
    ],
    requireLogin: true
  },
  mypageVisitApplicationList: {
    title: '見学申し込み病院一覧',
    desc: '',
    breadCrumb: [
      {
        label: 'マイページTOP',
        link: '/mypage'
      },
      {
        label: '見学申し込み病院一覧'
      }
    ],
    requireLogin: true
  },
  mypageVisitApplicationDetail: {
    title: '見学申し込み病院 見学内容の確認',
    desc: '',
    breadCrumb: [
      {
        label: 'マイページTOP',
        link: '/mypage'
      },
      {
        label: '見学申し込み病院一覧',
        link: '/mypage/visit_application/list'
      },
      {
        label: '見学申し込み病院 見学内容の確認'
      }
    ],
    requireLogin: true
  },
  mypageDocumentRequestList: {
    title: '資料請求病院一覧',
    desc: '',
    breadCrumb: [
      {
        label: 'マイページTOP',
        link: '/mypage'
      },
      {
        label: '資料請求病院一覧'
      }
    ],
    requireLogin: true
  },
  mypageDocumentRequestDetail: {
    title: '資料請求 資料請求内容の確認',
    desc: '',
    breadCrumb: [
      {
        label: 'マイページTOP',
        link: '/mypage'
      },
      {
        label: '資料請求病院一覧',
        link: '/mypage/visit_application/list'
      },
      {
        label: '資料請求 資料請求内容の確認'
      }
    ],
    requireLogin: true
  },
  mypageEvent: {
    title: '申込イベント一覧',
    desc: '',
    breadCrumb: [
      {
        label: 'マイページTOP',
        link: '/mypage'
      },
      {
        label: '申込イベント一覧'
      }
    ],
    requireLogin: true
  },
  myPageUserProfile: {
    title: '基本情報の確認',
    desc: '',
    breadCrumb: [
      {
        label: 'マイページTOP',
        link: '/mypage'
      },
      {
        label: '基本情報の確認'
      }
    ],
    requireLogin: true,
    loader: true
  },
  myPageUserProfileEdit: {
    title: '基本情報の変更',
    desc: '',
    breadCrumb: [
      {
        label: 'マイページTOP',
        link: '/mypage'
      },
      {
        label: '基本情報の確認',
        link: '/mypage/user/profile'
      },
      {
        label: '基本情報の変更'
      }
    ],
    requireLogin: true,
    loader: true
  },
  mypageCheckin: {
    title: 'イベントチェックイン',
    desc: '',
    breadCrumb: [
      {
        label: 'イベントチェックイン'
      }
    ],
    requireLogin: true,
    loader: true
  },
  mypageSavedCond: {
    title: '保存した検索条件',
    desc: '',
    breadCrumb: [
      {
        label: 'マイページTOP',
        link: '/mypage'
      },
      {
        label: '保存した検索条件'
      }
    ],
    requireLogin: true
  },
  mypageLeaveInput: {
    title:
      '退会　入力 | 未来のドクターへ、期待以上の出会いを。【マイナビRESIDENT】',
    desc: '',
    breadCrumb: [
      {
        label: 'マイページTOP',
        link: '/mypage'
      }
    ],
    requireLogin: true
  },
  mypageLeaveConfirm: {
    title:
      '退会　確認 | 未来のドクターへ、期待以上の出会いを。【マイナビRESIDENT】',
    desc: '',
    breadCrumb: [
      {
        label: 'マイページTOP',
        link: '/mypage'
      }
    ],
    requireLogin: true
  },
  mypageLeaveThanks: {
    title:
      '退会　完了 | 未来のドクターへ、期待以上の出会いを。【マイナビRESIDENT】',
    desc: '',
    breadCrumb: [
      {
        label: 'マイページTOP',
        link: '/mypage'
      }
    ]
  },
  magazines: {
    title: 'お役立ち情報トップ',
    desc:
      '病院選び、試験対策、研修期間に役立つヒントを随時掲載中です。 | 医学生や研修医の皆様に、出会いをつくることで日本の医療に貢献したい。私たちはマイナビRESIDENTです。',
    breadCrumb: [
      {
        label: 'お役立ち情報トップ'
      }
    ]
  },
  magazinesMatchingDetail: {
    title: 'スペシャルコンテンツ',
    desc:
      '病院選びに役立つヒントを随時掲載中です。 | 医学生や研修医の皆様に、出会いをつくることで日本の医療に貢献したい。私たちはマイナビRESIDENTです。',
    breadCrumb: [
      {
        label: 'スペシャルコンテンツ 一覧',
        link: '/magazines/special'
      }
    ]
  },

  magazinesSeries: {
    title: '連載 一覧',
    desc: '連載 一覧',
    breadCrumb: [
      {
        label: '連載 一覧'
      }
    ]
  },

  magazinesSeriesCategory: {
    breadCrumb: [
      {
        label: ''
      }
    ]
  },
  magazinesSpecial: {
    title: 'スペシャルコンテンツ 一覧',
    desc: 'スペシャルコンテンツ 一覧',
    breadCrumb: [
      {
        label: 'スペシャルコンテンツ 一覧'
      }
    ]
  },
  magazinesSpecialCategory: {
    breadCrumb: [
      {
        label: ''
      }
    ]
  },
  magazinesDetail: {
    breadCrumb: [
      {
        label: ''
      }
    ]
  },
  magazinesKeyword: {
    breadCrumb: [
      {
        label: ''
      }
    ]
  },
  examMaster: {
    title: '1日1問国試マスタートップ',
    desc: '',
    breadCrumb: [
      {
        label: '1日1問国試マスタートップ'
      }
    ]
  },
  examMasterDetail: {
    title: '1日1問国試マスター 問題',
    desc: '',
    breadCrumb: [
      {
        label: '1日1問国試マスタートップ',
        link: '/magazines/exam/master'
      },
      { label: '問題' }
    ]
  },
  examMasterList: {
    title: '1日1問国試マスター バックナンバー一覧',
    desc: '',
    breadCrumb: [
      {
        label: '1日1問国試マスタートップ',
        link: '/magazines/exam/master'
      },
      { label: 'バックナンバー一覧' }
    ]
  },
  examCbt: {
    title: '全国一斉CBT模擬試験トップ',
    desc: '',
    breadCrumb: [
      {
        label: '全国一斉CBT模擬試験トップ'
      }
    ],
    requireLogin: true
  },
  examCbtDetail: {
    title: '全国一斉CBT模擬試験 問題',
    desc: '',
    breadCrumb: [
      {
        label: '全国一斉CBT模擬試験トップ',
        link: '/magazines/exam/cbt'
      },
      {
        label: '問題'
      }
    ],
    requireLogin: true
  },
  examCbtFail: {
    title: '全国一斉CBT模擬試験 解答終了（制限時間切れ）',
    desc: '',
    breadCrumb: [
      {
        label: '全国一斉CBT模擬試験トップ',
        link: '/magazines/exam/cbt'
      },
      {
        label: '解答終了'
      }
    ],
    requireLogin: true
  },
  examCbtResult: {
    title: '全国一斉CBT模擬試験 成績発表',
    desc: '',
    breadCrumb: [
      {
        label: '全国一斉CBT模擬試験トップ',
        link: '/magazines/exam/cbt'
      },
      {
        label: '成績発表'
      }
    ],
    requireLogin: true
  },
  examCbtAllResult: {
    title: '全国一斉CBT模擬試験 成績発表（総合成績）',
    desc: '',
    breadCrumb: [
      {
        label: '全国一斉CBT模擬試験トップ',
        link: '/magazines/exam/cbt'
      },
      {
        label: '総合成績'
      }
    ],
    requireLogin: true
  },

  eventList: {
    title: 'イベント一覧 | イベント案内',
    desc:
      '研修先病院と直接コミュニケーションが取れるイベントを随時開催中です。',
    breadCrumb: [
      {
        label: 'イベント一覧'
      }
    ]
  },
  eventDetail: {
    title: 'イベント詳細 | イベント案内',
    breadCrumb: [
      {
        label: 'イベント一覧',
        link: '/events/list'
      },
      {
        label: 'イベント詳細'
      }
    ]
  },
  eventsReserveInput: {
    title: 'イベント予約 入力',
    desc: '',
    breadCrumb: [
      {
        label: 'イベント予約 入力'
      }
    ],
    loader: true
  },
  eventsReserveConfirm: {
    title: 'イベント予約 確認',
    desc: '',
    breadCrumb: [
      {
        label: 'イベント予約 確認'
      }
    ]
  },
  eventsReserveThanks: {
    title: 'イベント予約 完了',
    desc: '',
    breadCrumb: [
      {
        label: 'イベント予約 完了'
      }
    ]
  },
  eventArchiveList: {
    title: 'イベントアーカイブ一覧 | イベント案内',
    desc:
      '研修先病院と直接コミュニケーションが取れるイベントを随時開催中です。',
    breadCrumb: [
      {
        label: 'イベントアーカイブ一覧'
      }
    ]
  },
  password: {
    title:
      'パスワードを忘れた方　入力 | 未来のドクターへ、期待以上の出会いを。【マイナビRESIDENT】',
    breadCrumb: [
      {
        label: 'トップ',
        link: '/'
      },
      {
        label: 'パスワードを忘れた方　入力'
      }
    ]
  },
  passwordSendmail: {
    title:
      'パスワードを忘れた方　メール送信完了 | 未来のドクターへ、期待以上の出会いを。【マイナビRESIDENT】',
    breadCrumb: [
      {
        label: 'トップ',
        link: '/'
      },
      {
        label: 'パスワードを忘れた方　メール送信完了'
      }
    ]
  },
  passwordInput: {
    title:
      'パスワードの再設定 | 未来のドクターへ、期待以上の出会いを。【マイナビRESIDENT】',
    breadCrumb: [
      {
        label: 'トップ',
        link: '/'
      },
      {
        label: 'パスワードの再設定'
      }
    ]
  },
  passwordComplete: {
    title:
      'パスワードの再設定　完了 | 未来のドクターへ、期待以上の出会いを。【マイナビRESIDENT】',
    breadCrumb: [
      {
        label: 'トップ',
        link: '/'
      },
      {
        label: 'パスワードの再設定　完了'
      }
    ]
  },
  news: {
    title: '新着ニュース 一覧',
    desc: 'サービスに関する最新情報。',
    breadCrumb: [
      {
        label: '新着ニュース 一覧'
      }
    ]
  },
  newsDetail: {
    title: 'ニュース',
    desc: '',
    breadCrumb: [
      {
        label: '新着ニュース 一覧',
        link: '/news'
      }
    ]
  },
  faq: {
    title: 'よくある質問 一覧',
    desc: 'サービスや研修先病院探しに関する、よくある質問集。',
    breadCrumb: [
      {
        label: 'よくある質問 一覧'
      }
    ]
  },
  faqList: {
    title: 'よくある質問',
    desc: '',
    breadCrumb: [
      {
        label: 'よくある質問 一覧',
        link: '/faq'
      }
    ],
    loader: true
  },
  contactInput: {
    title: 'お問い合わせ 入力',
    desc: 'サービスに関するお問い合わせ。',
    breadCrumb: [
      {
        label: 'お問い合わせ 入力'
      }
    ]
  },
  contactConfirm: {
    title: 'お問い合わせ 確認',
    desc: '',
    breadCrumb: [
      {
        label: 'お問い合わせ 確認'
      }
    ]
  },
  contactThanks: {
    title: 'お問い合わせ 完了',
    desc: '',
    breadCrumb: [
      {
        label: 'お問い合わせ 完了'
      }
    ]
  },
  lpService: {
    title: 'マイナビ 医師向けサービスのご案内',
    desc: 'マイナビRESIDENTの医師向け各種サービスのご案内。',
    breadCrumb: [
      {
        label: 'マイナビ 医師向けサービスのご案内'
      }
    ]
  },
  lpSupporters: {
    title: '医学生サポーター募集',
    desc: 'マイナビRESIDENTの医学生サポーターを募集しています。',
    breadCrumb: [
      {
        label: '医学生サポーター募集'
      }
    ]
  },
  lpHpcr: {
    title: 'ヒポクラご利用案内',
    desc:
      '医師のための臨床互助ツール「ヒポクラ」のご利用方法について。',
    breadCrumb: [
      {
        label: 'ヒポクラご利用案内'
      }
    ]
  },
  lpEtc: {
    title: '',
    desc: '',
    breadCrumb: [],
    loader: true
  },
  guide: {
    title: 'ご利用ガイド',
    desc: 'マイナビRESIDENTのご利用方法。',
    breadCrumb: [
      {
        label: 'ご利用ガイド'
      }
    ]
  },
  terms: {
    title: '利用規約・個人情報保護方針',
    desc: 'マイナビRESIDENTの利用規約や個人情報保護方針。',
    breadCrumb: [
      {
        label: '利用規約・個人情報保護方針'
      }
    ]
  },
  privacyPolicy: {
    title: '個人情報の取り扱いについて',
    desc: 'マイナビRESIDENTのプライバシーポリシー。',
    breadCrumb: [
      {
        label: '個人情報の取り扱いについて'
      }
    ]
  },
  sitemap: {
    title: 'サイトマップ',
    desc: 'マイナビRESIDENTのサイトマップ。',
    breadCrumb: [
      {
        label: 'サイトマップ'
      }
    ]
  },
  lpSpEvent20210504: {
    title: '東海北陸地区 臨床研修病院合同説明会',
    desc: '東海北陸地区 臨床研修病院合同説明会について紹介します。',
    breadCrumb: [
      {
        label: '東海北陸地区 臨床研修病院合同説明会'
      }
    ]
  },
  lpSpEvent20210718: {
    title: '東海北陸地区 臨床研修病院合同説明会',
    desc:
      '2021年7月18日（日）に開催する東海北陸地区 臨床研修病院合同説明会について紹介します。',
    breadCrumb: [
      {
        label: '東海北陸地区 臨床研修病院合同説明会'
      }
    ]
  },
  notFound: {
    title: '404 Not Found',
    desc: '',
    breadCrumb: []
  }
}
